// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2XFBd","left":"InfoRow_left__3Hq0d"};